export const listMutations = <const>{
	VOZIDLO_SELECT_MAPPER: 'VOZIDLO_SELECT_MAPPER',
	ZAKAZNIK_SELECT_MAPPER: 'ZAKAZNIK_SELECT_MAPPER',
};

export const editMutations = <const>{
	ZAKAZNIK_SELECT_MAPPER: 'ZAKAZNIK_SELECT_MAPPER',
};
